import './App.css';

import TimeTracker from './components/TimeTracker';

function App() {
  return (
    <div className="App">
      <TimeTracker />
    </div>
  );
}

export default App;
